import _, { result } from "lodash";
import vm from "../main";
import { API } from "../config";
import { httpClient as http } from "../services";

const internals = {};

internals.getDriverList = function() {
  return http.get("/register/driver/list");
};

internals.getDriverList = (Id) => {
  return http
    .get(`/register/driver/list?cityId=${Id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("transPortTripService-error:\n", error);
      throw error;
    });
};

internals.vehicleList = (Id) => {
  return http
    .get(`/vehicle/list/number?cityId=${Id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("transPortTripService-error:\n", error);
      throw error;
    });
};

internals.vehicleMaintenanceList = function() {
  return http.get("/vehicle-maintenance/list?page=1&limit=10", payload);
};

internals.createVehicleMaintenance = function(payload) {
  return http
    .post("/vehicle-maintenance/create", payload)
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error("vehicleMaintenance.create-error:\n", error);
      throw error;
    });
};

internals.updateVehicleMaintenance = function(payload) {
  return http
    .put("/vehicle-maintenance/update", payload)
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error("vehicleMaintenance.update-error:\n", error);
      throw error;
    });
};

internals.deleteVehiclemaintenance = (_id) => {
  return http
    .delete(`/vehicle-maintenance/delete?_id=` + _id)
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error("vehicleMaintenance.delete-error:\n", error);
      throw error;
    });
};

internals.getvehicleMaintenanceById = function(id) {
  return http
    .put("/vehicle-maintenance/getById?_id=" + id)
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error(
        "vehicleMaintenance.getVehicleMaintenanceById-error:\n",
        error
      );
      throw error;
    });
};

internals.getVehicleMaintenanceDataByID = function(id) {
  return http
    .get("/vehicle-maintenance/getById?_id=" + id)
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error(
        "vehicleMaintenance.getVehicleMaintenanceById-error:\n",
        error
      );
      throw error;
    });
};

internals.getvehicleNumber = function() {
  return http
    .get("/vehicle/list/number")
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error(
        "vehicleMaintenance.getVehicleMaintenanceById-error:\n",
        error
      );
      throw error;
    });
};

export default internals;



// WEBPACK FOOTER //
// ./src/services/vehiclemaintenance.service.js